import timg1 from '../images/team/img-1.jpg'
import timg2 from '../images/team/img-2.jpg'
import timg3 from '../images/team/img-3.jpg'
import timg4 from '../images/team/img-4.jpg'


const Teams = [
    {
        Id:'1',
        tImg:'https://images.unsplash.com/photo-1570470836811-78ef04bb23d3?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        name:'Mr. Waseem Khan',
        title:'CEO, MAAKSONS',
        description: 'Over 70 years of delivering transformational infrastructure across Pakistan — roads, bridges, high-rise buildings, and diplomatic facilities. Each project reflects our passion for engineering and a commitment to excellence.'
    },
    {
        Id:'2',
        tImg:'https://images.unsplash.com/photo-1581093804475-577d72e38aa0?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjN8fGVuZ2luZWVyfGVufDB8fDB8fHww',
        name:'Marcus',
        title:'Lead Architect - ARCHI-TEX UAE',
        description: 'Globally recognized architect with over 28 years of experience across the UK, Europe, Middle East, and Asia. Portfolio exceeds 30 million sq. ft. with prestigious awards including Cityscape Award for Emporium Mall Lahore.'
    },
    {
        Id:'3',
        tImg:'https://www.shutterstock.com/image-photo/asian-engineer-handsome-man-architect-600nw-2054685725.jpg',
        name:'Mr. M. A. Aleem Khan',
        title:'Founder, MAAKSONS (1951)',
        description: 'Founded MAAKSONS as a pioneering civil contractor, growing it into one of Pakistan\'s most trusted and diversified construction powerhouses. Legacy continues through MAAKDREAM in Dubai.'
    },
    {
        Id:'4',
        tImg:'https://www.shutterstock.com/image-photo/happy-confident-young-attractive-arabic-600nw-2107625390.jpg',
        name:'MAAKSONS Team',
        title:'Engineering Excellence',
        description: 'Over 7 decades of continuous operations in engineering, construction, and urban development. Specialized in roads, bridges, embassies, tunnels, flyovers, commercial towers, and mega public-private ventures.'
    },
]

export default Teams;